import type { State } from './GlobalFieldsTourSteps.types.tsx';

export const getProductUsageStartTimestamp = (state: State): string | undefined =>
	state.productUsageStartTimestamp;
